import { combineReducers } from 'redux';
import { reducer as form } from './State/form';
import { reducer as submitting } from './State/submitting';
import { reducer as procurementItem } from './State/procurementItem';

export default combineReducers({
  form,
  submitting,
  procurementItem,
});
